<template>
  
  <div class="footer">
    <div class="footer_left">
      copyright 2020 4shelves. All right reserved.
    </div>

    <div class="footer_right">
      유진언어연구소와 임은경이 만들었습니다
    </div>
  </div>
</template>

<script>
export default {

}
</script>

<style>

.footer {
  
  justify-content: space-between;
   
 }

.footer_left {

  justify-content: flex-start;
  padding-top: 10px;
  padding-left: 10px;
  font-size: 12px;
}

.footer_right {
  
  justify-content: flex-end;
  padding-top: 10px;
  padding-right: 10px;
  font-size: 12px;

}

</style>